import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../conditionScoreAction';
import fetchApi from "./fetchApi";

function fetchConditionScoreAction() {
  return fetchApi('/v1/fc_api/condition_score_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchConditionScoreAction;
